<script setup>
import EmptyStateLayout from 'dashboard/components-next/EmptyStateLayout.vue';

defineProps({
  title: { type: String, default: 'Nenhum pipeline configurado' },
  subtitle: {
    type: String,
    default:
      'Pipelines organizam o ciclo de vida dos leads - Vendas, Manutenção, Pós-venda. Crie a partir de um template em segundos.',
  },
});

const SAMPLES = [
  {
    name: 'Vendas',
    color: '#10b981',
    description: 'Funil comercial: novo → contato feito → proposta → fechamento',
    stages: 6,
    template: 'vendas',
  },
  {
    name: 'Manutenção',
    color: '#3b82f6',
    description: 'Atendimentos de assistência técnica e recall',
    stages: 5,
    template: 'manutencao',
  },
  {
    name: 'Pós-venda',
    color: '#8b5cf6',
    description: 'Relacionamento, sucesso do cliente e recompra',
    stages: 5,
    template: 'pos_venda',
  },
];
</script>

<template>
  <EmptyStateLayout :title="title" :subtitle="subtitle">
    <template #empty-state-item>
      <div class="flex flex-col gap-3 p-px">
        <div
          v-for="(p, i) in SAMPLES"
          :key="i"
          class="rounded-xl border border-n-weak bg-n-solid-1 px-4 py-3 flex items-center gap-4"
        >
          <span
            class="size-10 rounded-full flex items-center justify-center flex-shrink-0"
            :style="{ background: `${p.color}1f` }"
          >
            <i class="i-lucide-kanban size-5" :style="{ color: p.color }" />
          </span>
          <div class="flex-1 min-w-0">
            <div class="flex items-center gap-2">
              <p class="text-heading-3 text-n-slate-12 mb-0">{{ p.name }}</p>
              <span class="inline-flex items-center px-1.5 py-0.5 rounded bg-n-brand/10 text-label-small font-medium text-n-brand uppercase tracking-wide">
                {{ p.template }}
              </span>
            </div>
            <p class="text-body-small text-n-slate-11 mt-0.5 mb-0 line-clamp-1">{{ p.description }}</p>
            <div class="flex items-center gap-3 mt-1 text-body-small text-n-slate-10">
              <span class="inline-flex items-center gap-1">
                <i class="i-lucide-layers size-3" />
                {{ p.stages }} stages
              </span>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template #actions>
      <slot name="actions" />
    </template>
  </EmptyStateLayout>
</template>
